import { FuturisticWindow } from './FuturisticWindow';
import { Box3, Vector2, Vector3 } from 'three';
import { PRIMARY_TEXT_COLOR } from '../styleConfig';
import { TextComponent, Viewer, ViewerModule, Tween } from '@verybigthings/vbt-webvr-framework';
export default class TaskScreen extends ViewerModule {
    constructor() {
        super();
        this.backgroundCreated = false;
        this.offSet = 0;
        this.addObject(this.background = new FuturisticWindow({
            size: new Vector2(8, 5),
            radius: 0.15,
            type: 1,
            hasSideImage: false,
            borderWidth: 0.08,
        }));
        // Viewer.on('update', () => this.uiObject.lookAt(Viewer.camera.localToWorld(new Vector3())));
        this.background.uiObject.position.y = 0.2;
        this.background.uiObject.position.z = -0.2;
        this.addObject(this.taskNumber = new TextComponent({
            size: new Vector2(1.1, 1.1),
            pxSize: new Vector2(64, 64),
            text: {
                style: { family: 'Nunito', weight: '800', color: PRIMARY_TEXT_COLOR.getStyle(), size: '18px' },
                value: '',
                align: 'left',
                lineHeight: 16,
                autoWrappingHorizontal: true,
                margin: { bottom: 10 }
            },
            background: { color: 'transparent' }
        }));
        this.taskNumber.uiObject.position.z = 0.03;
        this.taskNumber.uiObject.position.y = 2.1;
        this.addObject(this.header = new TextComponent({
            size: new Vector2(7, 1),
            pxSize: new Vector2(448, 64).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: { size: `${28 * (window['quality'] === 'very low' ? 1 : 1)}px`, family: 'Nunito', weight: '800', color: PRIMARY_TEXT_COLOR.getStyle() },
                lineHeight: 28 * (window['quality'] === 'very low' ? 1 : 1),
                value: '',
                align: 'left',
                autoWrappingHorizontal: false,
                autoWrapping: true,
                margin: { bottom: 18 }
            },
            background: { color: 'transparent' }
        }));
        this.header.uiObject.position.z = 0.02;
        this.header.uiObject.position.y = 1.10;
        this.addObject(this.text = new TextComponent({
            size: new Vector2(7, 1),
            pxSize: new Vector2(448, 64).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: { size: `${23 * (window['quality'] === 'very low' ? 1 : 1)}px`, family: 'Nunito', weight: '400', color: PRIMARY_TEXT_COLOR.getStyle() },
                value: '',
                autoWrappingHorizontal: false,
                lineHeight: 25 * (window['quality'] === 'very low' ? 1 : 1),
                align: 'left',
                autoWrapping: true,
                margin: { bottom: 36 }
            },
            background: { color: 'transparent' }
        }));
        this.text.uiObject.position.z = 0.03;
        this.text.uiObject.position.y = -0.4;
    }
    init(taskText, headerText, mainText, offSet = 0) {
        if (!this.backgroundCreated) {
            this.background.init();
            this.backgroundCreated = true;
        }
        this.taskNumber.setText(taskText);
        this.header.setText(headerText);
        this.text.setText(mainText);
        this.offSet = typeof (offSet) === 'string' ? parseFloat(offSet) : offSet;
        this.offSet -= 0.2;
        this.adjustTexts();
    }
    adjustTexts() {
        // ViewerModule.adjustObjects([this.text.uiObject, this.header.uiObject], false, 0);
        // ViewerModule.adjustObjects([this.text.uiObject, this.header.uiObject, this.taskNumber.uiObject], false, 0);
        [this.taskNumber, this.header, this.text].forEach(a => {
            const obj = a.uiObject;
            obj.position.x = 0;
            obj.updateMatrixWorld(true);
            const box = new Box3();
            box.setFromObject(obj);
            const size = new Vector3();
            box.getSize(size);
            obj.userData.size = a.mesh.geometry.boundingBox.getSize(new Vector3());
            obj.position.x = -(this.background.options.size.x / 2 - obj.userData.size.x / 2) + 0.3;
        });
        this.taskNumber.uiObject.position.x += 0.1;
        this.header.uiObject.position.y = this.taskNumber.uiObject.position.y - this.taskNumber.uiObject.userData.size.y / 2 - this.header.uiObject.userData.size.y / 2;
        this.text.uiObject.position.y = this.header.uiObject.position.y - this.header.uiObject.userData.size.y / 2 - this.text.uiObject.userData.size.y / 2;
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
    flyTo(pos, time = 1000, onComplete) {
        if (Viewer.controls.zController)
            return;
        let flyAnim = new Tween(this.uiObject.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((delta) => {
            this.uiObject.lookAt(this.camera.localToWorld(new Vector3()));
        })
            .onComplete(() => {
            console.log('fly end');
            this.uiObject.lookAt(this.camera.localToWorld(new Vector3()));
            // flyAnim.stop();
            this.adjustTexts();
            onComplete && onComplete();
        })
            .start();
    }
}
